import { render, staticRenderFns } from "./consultationService.vue?vue&type=template&id=5e037807&scoped=true&"
import script from "./consultationService.vue?vue&type=script&lang=js&"
export * from "./consultationService.vue?vue&type=script&lang=js&"
import style0 from "./consultationService.vue?vue&type=style&index=0&id=5e037807&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e037807",
  null
  
)

export default component.exports